import React, { useState } from "react";
import { BsThreeDots } from "react-icons/bs";
import {
  MdOutlineRemoveRedEye,
  MdArrowForwardIos,
} from "react-icons/md";
import { LiaUserPlusSolid } from "react-icons/lia";
import { TiDeleteOutline } from "react-icons/ti";
import { TbEdit } from "react-icons/tb";
import { BsCopy } from "react-icons/bs";
import { AiOutlineAudit } from "react-icons/ai";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import copy from "copy-to-clipboard";
import { Tooltip } from "react-tooltip";
import moment from "moment";

function CustomList(props) {
  const MoreManu = ({ item }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () =>
      setDropdownOpen((prevState) => !prevState);

    return (
      <div className="moreMenu">
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle caret>
            <BsThreeDots />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => props.pwDetailstoggle(item)}>
              <MdOutlineRemoveRedEye /> View Details
            </DropdownItem>
            <DropdownItem onClick={() => props.sharetoggle(item)}>
              <LiaUserPlusSolid /> Share Password
            </DropdownItem>
            {/* <DropdownItem
              onClick={() => props.addNotetoggle(item?._id)}
            >
              <PiNote /> Add Note
            </DropdownItem> */}
            {/* <DropdownItem onClick={() => props.movetoggle(item?._id)}>
              <RiFolderTransferLine /> Move Password
            </DropdownItem> */}
            {/* <DropdownItem>
                      <RiFolderAddLine /> Move password in to a new
                      folder 
                    </DropdownItem> */}
            <DropdownItem onClick={() => props.edittoggle(item)}>
              <TbEdit /> Edit Password
            </DropdownItem>
            <DropdownItem onClick={() => props.allLogs(item)}>
              <AiOutlineAudit /> Logs
            </DropdownItem>
            <DropdownItem onClick={() => props.confirmtoggle(item)}>
              <TiDeleteOutline /> Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  const CopyIcon = (cp) => {
    const [copied, setCopied] = useState(false);
    const [seconds, setSeconds] = useState(0);
    const timer = () => {
      const myTimeout = setTimeout(frame, 30000);
      function frame() {
        clearTimeout(myTimeout);
        try {
          navigator.clipboard.writeText(" ");
        } catch (error) {
          console.log(error);
        }
      }
    };
    return (
      <div
        onClick={async () => {
          const res = await cp.onCopy();
          copy(res);
          setSeconds(0);
          setCopied(true);
          timer();
        }}
        data-tooltip-id={cp?.id}
        data-tooltip-content={copied ? "Copied!" : "Copy"}
      >
        {seconds > 0 ? <span>{seconds}</span> : null}

        <BsCopy
          style={{
            width: "15px",
            height: "15px",
            cursor: "pointer",
            margin: 3,
          }}
          color="A2C1D8"
        />
        <Tooltip place="top" effect="float" id={cp?.id} />
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <table className="table tableData" style={{ margin: "0px" }}>
        <thead>
          <tr>
            <th
              style={{
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
              }}
            >
              <Input
                type="checkbox"
                style={{
                  width: "18px",
                  height: "18px",
                  border: "1px solid #131313",
                  cursor: "pointer",
                }}
                checked={props?.allSelected}
                onChange={(e) => {
                  props?.selectAll();
                }}
              />
            </th>
            <th>Identifier</th>
            <th></th>
            <th>Host/ Domain</th>
            <th>Port</th>
            <th>Username/API Key</th>
            <th>Password/API Secret</th>
            <th>Type</th>
            <th>Updated On</th>
            <th
              style={{
                borderTopRightRadius: "6px",
                borderBottomrightRadius: "6px",
              }}
            ></th>
          </tr>
        </thead>
        <tbody>
          {props.data?.map((item, index) => {
            return (
              <tr
                key={"list" + index}
                className={
                  props?.splitItemId === item?._id ? "selected" : ""
                }
              >
                <td>
                  <Input
                    type="checkbox"
                    style={{
                      width: "18px",
                      height: "18px",
                      border: "1px solid #131313",
                      cursor: "pointer",
                    }}
                    checked={props.selectedItems.includes(item._id)}
                    onChange={(e) => {
                      props.selectCheckBox(item._id);
                    }}
                  />
                </td>
                <td>
                  <div className="icon-plus-value">
                    {item?.identifier}
                  </div>
                </td>
                <td>
                  <div
                    className="folder-name"
                    style={{ background: item?.color }}
                  >
                    {item?.folderName || "Root"}
                  </div>
                </td>
                <td>
                  <div className="icon-plus-value">
                    <CopyIcon
                      id={item?.platform}
                      onCopy={() => {
                        return item?.platform;
                      }}
                    />
                    <span>{item?.platform || "NA"}</span>
                  </div>
                </td>
                <td>{item?.port || "NA"}</td>
                <td width={"20%"}>
                  <div className="icon-plus-value">
                    <CopyIcon
                      id={item?.username || item?.apiKey}
                      onCopy={() => {
                        return item?.username || item?.apiKey;
                      }}
                    />
                    <div
                      style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {item?.username?.slice(0, 4) +
                        item?.username
                          ?.slice(4, item?.username?.length)
                          .replace(/\S/g, "*") ||
                        item?.apiKey?.slice(0, 4) +
                          item?.apiKey
                            ?.slice(4, item?.apiKey?.length - 4)
                            .replace(/\S/g, "*") ||
                        "NA"}
                    </div>
                  </div>
                </td>
                <td>
                  <div className="icon-plus-value">
                    <CopyIcon
                      id={item?.identifier}
                      onCopy={async () => {
                        const a = await props?.onCopypassword(
                          item?.passwordId
                            ? item?.passwordId
                            : item?._id
                        );
                        return a;
                      }}
                    />
                    <span>***********</span>
                  </div>
                </td>
                <td>{item?.passwordType}</td>
                <td>{moment(item?.updatedAt).format("lll")}</td>
                {/* <td>JAN 18,2023 | 2:35 PM</td> */}
                <td>
                  {props?.splitView ? (
                    <MdArrowForwardIos
                      onClick={() => props?.setSplitData(item)}
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                        margin: 3,
                      }}
                    />
                  ) : (
                    <MoreManu item={item} />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default CustomList;
